<tool-drawer-container (openFormDialog)="openDialog()">
  <course-recommender-form class="form-slot"></course-recommender-form>

  <tool-header
    class="tool-header"
    headerTitle="Course Recommender"
    subtitle="View recommended courses for a selected student based on their taken courses"
  ></tool-header>

  <courses-recommender-content
    class="main-content"
  ></courses-recommender-content>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Course Recommender'
      )
    "
  ></related-links>
</tool-drawer-container>
